import { cx } from "@emotion/css";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import { useAuthContext } from "@/modules/auth/hooks/useAuthContext";
import { authenticatedRouting } from "@/modules/router/routings/authenticatedRouting";
import { useTheme } from "@/modules/theme/hooks/useTheme";

import { createNavMenuStyles } from "./helpers/createNavMenuStyles";

export function NavMenu() {
  const { t } = useTranslation(
    "layouts/AuthenticatedLayout/components/NavMenu"
  );
  const theme = useTheme();
  const classes = createNavMenuStyles(theme);
  const { hasAdminPrivilages } = useAuthContext();

  return (
    <nav className={classes.root}>
      <ul className={classes.navigationList}>
        <li>
          <NavLink
            className={cx(classes.navigationLink, classes.tasks)}
            activeClassName={cx(classes.linkActive, classes.tasksActive)}
            to={authenticatedRouting.buildUrl("tasks")}
            exact
          >
            {t("Tasks")}
          </NavLink>
        </li>
        <li>
          <NavLink
            className={cx(classes.navigationLink, classes.tutorials)}
            activeClassName={cx(classes.linkActive, classes.tutorialsActive)}
            to={authenticatedRouting.buildUrl("tutorials")}
          >
            {t("Tutorials")}
          </NavLink>
        </li>
        <li>
          <NavLink
            className={cx(classes.navigationLink, classes.levels)}
            activeClassName={cx(classes.linkActive, classes.levelsActive)}
            to={authenticatedRouting.buildUrl("levels")}
          >
            {t("Levels")}
          </NavLink>
        </li>
        {hasAdminPrivilages ? (
          <li>
            <NavLink
              className={cx(classes.navigationLink, classes.dashboard)}
              activeClassName={cx(classes.linkActive, classes.dashboardActive)}
              to={authenticatedRouting.buildUrl("dashboard")}
            >
              {t("Dashboard")}
            </NavLink>
          </li>
        ) : (
          <li>
            <NavLink
              className={cx(classes.navigationLink, classes.handbook)}
              activeClassName={cx(classes.linkActive, classes.handbookActive)}
              to={authenticatedRouting.buildUrl("handbooks")}
            >
              {t("Handbook")}
            </NavLink>
          </li>
        )}
        <li>
          <NavLink
            className={cx(classes.navigationLink, classes.more)}
            activeClassName={cx(classes.linkActive, classes.moreActive)}
            to={authenticatedRouting.buildUrl("more")}
          >
            {t("More")}
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}
